/**
 * Shared schema.org Offer fragments so every Product listing on the site
 * satisfies Google Merchant listings requirements:
 *   hasMerchantReturnPolicy, shippingDetails, validFrom, description.
 * Keep these values in sync with the shipping & return policies.
 */

export const OFFER_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy",
  applicableCountry: "IN",
  returnPolicyCountry: "IN",
  returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
  merchantReturnDays: 3,
  returnMethod: "https://schema.org/ReturnByMail",
  returnFees: "https://schema.org/FreeReturn",
} as const;

export const OFFER_SHIPPING_DETAILS = {
  "@type": "OfferShippingDetails",
  shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "INR" },
  shippingDestination: { "@type": "DefinedRegion", addressCountry: "IN" },
  deliveryTime: {
    "@type": "ShippingDeliveryTime",
    handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 1, unitCode: "DAY" },
    transitTime: { "@type": "QuantitativeValue", minValue: 2, maxValue: 5, unitCode: "DAY" },
  },
} as const;

/** Start of the current year — a stable, always-valid offer start date. */
export function offerValidFrom(): string {
  return `${new Date().getFullYear()}-01-01`;
}

export function offerValidUntil(): string {
  return `${new Date().getFullYear() + 1}-12-31`;
}

/** Fields every Offer / AggregateOffer on the site must carry. */
export function merchantOfferExtras() {
  return {
    validFrom: offerValidFrom(),
    priceValidUntil: offerValidUntil(),
    hasMerchantReturnPolicy: OFFER_RETURN_POLICY,
    shippingDetails: OFFER_SHIPPING_DETAILS,
  };
}
